export default "__VITE_ASSET__Vq3pr4cR__";